export default (state = {}, action) => {
  if (action.type === "SET_FIELD_LABEL") {
    return { ...state, [action.field]: action.label };
  }

  return state;
};
